import { render, staticRenderFns } from "./GeneralGroupChart.vue?vue&type=template&id=033db837&scoped=true"
import script from "./GeneralGroupChart.vue?vue&type=script&lang=js"
export * from "./GeneralGroupChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033db837",
  null
  
)

export default component.exports